<template>
  <div  class="blacklistContainer">
    <b-container fluid>
     <b-row ><b-col class="m-0 p-0"><h1 class="black-list-heading">Blacklist</h1></b-col>
      </b-row>
      <div class="message-list">
        <b-row id="msgOptions">
        <b-col cols="1" class="backToMessages">
          <router-link
            :to="{
              name: 'Messages',
            }"
          >
            <button class="backToMessagesBtn">
              <i class="fas fa-arrow-left"></i>
            </button>
          </router-link>
        </b-col>
        <b-col cols="11 blacklist-info-container" >
          <p class="blacklist-info"> The following members won't be able to send messages to you</p>
        </b-col>
      </b-row>
        <b-row class="chat-conversations" v-for="user in blacklistedUser" :key="user.id">
          <b-col cols="5" class="userSection" @click="()=>{$router.push({ name: 'currentMessage',
            params: { chatRoomId: user.chat_room_id }})}">
            <div class="userImg">
              <img
                class="profPic"
                :src="$lodash.get(user, 'receiver.customer.profile_picture')"
              />
            </div>

              <div class="userDetails" v-if="user.receiver">
                <p class="username">
                  {{ user.receiver.first_name }} {{ user.receiver.last_name }}
                </p>
                <p class="userPosition">
                  {{ $lodash.get(user, "receiver.customer.job_title") }}
                </p>
                <p class="userCompany">
                  {{ $lodash.get(user, "receiver.customer.company.name") }}
                </p>
              </div>

          </b-col>
          <b-col cols="4" class="msgContent">
            <p v-if="user.messages.length"> {{user.messages[0].content}}</p>
          </b-col>
          <b-col cols="2" class="dateSection">
            <p class="msgTime">
              {{ moment(user.last_message_date).format("YYYY-MM-DD") }}
            </p>
          </b-col>
          <b-col cols="1" class="deleteSection">
            <button
              title="Remove from blacklist"
              @click="getBlockedUserId(user.id)"
            >
              <i class="fas fa-times"></i>
            </button>
            <b-modal v-model="modalShow" hide-footer title="Remove from black list?">
              <div id="blockModalBody">
                <div class="modal-button-wrapper">
                  <b-button
                    class="mt-3"
                    variant="outline-success"
                    block
                    @click="del()"
                    >Yes</b-button
                  >
                  <b-button class="mt-3 cancel" block @click="modalShow = !modalShow"
                    >Close</b-button
                  >
                </div>
              </div>
            </b-modal>
          </b-col>
        </b-row>
      </div>
    </b-container>

    <div v-if="!blacklistedUser.length" class="blacklistedUser">
      <p>Empty</p>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';

export default {
  data() {
    return {
      visible: true,
      modalShow: false,
      blacklistedUser: {},
      lastMessageToShow: null,
      blockedUserId: null,
    };
  },
  methods: {
    ...mapActions({
      blacklist: 'messages/blacklist',
      unblockConversation: 'messages/unblockConversation',
    }),
    moment(date) {
      return moment(new Date(date));
    },
    removeTask() {
      this.$refs['my-modal'].show();
    },
    getBlockedUserId(id) {
      this.blockedUserId = id;
      this.modalShow = !this.modalShow;
    },
    del() {
      this.blacklistedUser = [
        ...this.blacklistedUser.filter(({ id }) => id !== this.blockedUserId),
      ];
      try {
        this.unblockConversation(this.blockedUserId);
        this.modalShow = !this.modalShow;
      } catch (err) {
        console.log(err);
      }
    },
  },
  async mounted() {
    const { result } = await this.blacklist();
    this.blacklistedUser = result.docs;
  },
};
</script>

<style src="./Messages.css" scoped></style>
